import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function InstrumentationBulk() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        Instrumentation Bulk Oil & Gas Products UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides instrumentation bulk solutions for oil and gas projects in the UAE, including instrumentation cables, control cables, cable glands, MCT systems, junction boxes, tubing and fittings, valves, manifolds and instrumentation accessories."
    />

    <meta
        name="keywords"
        content="instrumentation bulk UAE, instrumentation oil gas UAE, instrumentation cables UAE, control cables UAE, instrumentation tubing UAE, instrumentation fittings UAE, instrumentation valves UAE, cable glands UAE, multi cable transit system UAE, instrumentation junction boxes UAE, oil gas instrumentation supplier UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/InstrumentationBulk"
    />

    <meta
        property="og:title"
        content="Instrumentation Bulk Oil & Gas Products UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Reliable instrumentation bulk products for oil and gas applications, including cables, glands, MCT systems, junction boxes, tubing, valves and accessories."
    />

    <meta
        property="og:url"
        content="https://saig.me/InstrumentationBulk"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Instrumentation Bulk - Oil & Gas </h6>
                    <p className=" w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Reliable and proven products for the hazardous area application
                    </p>
                </div>
            </div>
               <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Instrumentation Bulk - Oil & Gas </h2>
  <div className='line'></div>

                         {/* <h3 className='text-left mb-[20px]'>Instrumentation & Control Cables, Thermocouple Cables, Cable Glands, Cable Lugs & Terminals, Instrumentation Tubing, Instrumentation Tube Fittings & Pipe Fittings, Tube Clamps, Valves & Manifolds, Junction box, Sunshades, Stanchion, Multi Cable Transit System (this is tagline)</h3> */}

                         <h3 className='text-left mb-[20px]'>A complete solution and range of instrumentation bulk needs including cables. Partnering with us helps reduce supplier risk and the cost of handling multiple vendors. Our supplies are classified and certified to meet specific project requirements, vendor lists and global safety standards. Our team has extensive technical project management experience - where reliability and consistency are a priority.</h3>

               </div>
               </div>

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/saigin.png' />
                    </div>


                </div>
<div className='detail-div-right service-details-div2-new'>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Cables</h4>
  </div>
  <p>
    Pair, Triad & Quad cables as per BS EN 50288-7 & CSA C22.2 #239 standards
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Control Cables</h4>
  </div>
  <p>
    Up to 61 core & signalling cables for industrial applications
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Specialised Cables</h4>
  </div>
  <p>
    Thermocouple extension, FO, Foundation Field Bus, Co-axial & LAN cables
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cable Glands & Accessories</h4>
  </div>
  <p>
    Industrial, hazardous, barrier types & thread conversion accessories
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Multi Cable Transit System</h4>
  </div>
  <p>
    MCT frames (welded & bolted), colour coded modules & supporting software
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Cable Tray & Support Systems</h4>
  </div>
  <p>
    Customised solutions in HDG, Stainless Steel & Aluminium
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Junction Box</h4>
  </div>
  <p>
    Customised junction boxes with retrofits in SS316L, Aluminium & GRP
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Tubing & Fittings</h4>
  </div>
  <p>
    NACE certified double compression fittings in SS316 & exotic materials
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Valves</h4>
  </div>
  <p>
    Ball valves, bleed valves, needle valves & manifolds
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Air Headers</h4>
  </div>
  <p>
    4-way to 20-way multiple valve centralised distribution manifolds
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Hose Assemblies</h4>
  </div>
  <p>
    Rubber, thermoplastic & stainless steel hose assemblies
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Stanchion & Sunshades</h4>
  </div>
  <p>
    GRP & SS316 options with multiple mounting configurations
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Instrumentation Accessories</h4>
  </div>
  <p>
    Printers, labels, connectors, sleeves, cable ties, terminals & tube clamps
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Hardware</h4>
  </div>
  <p>
    Tapes, adhesives, fasteners, warning signs, sign boards, glue & sealants
  </p>

</div>

            </div>
  <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>


                         <h3 className='text-left mb-[20px]'>Our knowledgeable staff can help you find the perfect products for your needs, so that you can rely on us to provide support through every stage of the project. The range is so vast that listing all the articles is impossible - please contact us for unlisted products.
<br/><br/>To ensure logistics we have tied with established freight forwarders undertaking Airfreights, FCL, LCL and chartered loads - ensuring totality !</h3>
  <Link to="/product">
                       <button className="backbtn mt-6">
                         Back To Products
                       </button>
                     </Link>
               </div>
               </div>
            {/* <section style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }} className='lg:px-[100px] px-[20px]'>
                         <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] lg:pb-[80px] pb-[40px]">Product Recommendation</h6>
                         <div className="grid lg:grid-cols-3 grid-cols-2 lg:gap-[36px] gap-[20px] lg:pb-[142px] pb-[80px]">
                             <div>
                                 <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                     <img src="/assets/product/img1.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                     <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                         View Details
                                     </button>
                                 </div>
                                 <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                     junction box & enclosures
                                 </h6>
                                 <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                     Polymer & Sheet Metal
                                 </p>
                             </div>
                             <div>
                                 <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                     <img src="/assets/product/img2.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                     <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                         View Details
                                     </button>
                                 </div>
                                 <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                     re-enterable gel 7 fillers
                                 </h6>
                                 <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                     Re-usable & Cast
                                 </p>
                             </div>
                             <div>
                                 <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                     <img src="/assets/product/img3.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                     <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                         View Details
                                     </button>
                                 </div>
                                 <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                     Cables
                                 </h6>
                                 <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                     Power & Instrumentation
                                 </p>
                             </div>
                         </div>
                     </section> */}
        </>
    )
}

export default InstrumentationBulk 